import styled from '@emotion/styled'

export const LabelButtonStyle = styled.button`
  overflow: hidden;
  color: var(--grayscale-light-gray, #bebebe);
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;
  text-overflow: ellipsis;
  /* Body/B2 - Fira - Regular */
  font-family: Fira Sans, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  height: 40px;
  border: 1px dashed transparent;
  border-radius: 6px;
  width: 100%;
  padding: 8px;

  :hover {
    border-color: #bebebe;
  }

  :active {
    background-color: #bebebe33;
  }
`

export const ButtonAddStyle = styled.button`
  border: 1px solid #595959;
  border-radius: 4px;
  padding: 8px;
  background-color: #000000;
  width: 100%;
  height: 40px;
  color: #bebebe;
  text-overflow: ellipsis;
  font-family: Fira Sans, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.28px;
  overflow: hidden;
  font-variant-numeric: lining-nums proportional-nums;
  /* Body/B2 - Fira - Medium */
  line-height: 20px; /* 142.857% */
`

export const ItemAuthorStyle = styled.div`
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #595959;
  font-family: Vollkorn, serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 125.37%; /* 15.044px */
  letter-spacing: -0.12px;
`

export const ItemButtonStyle = styled.button`
  padding: 4px;
  background: ${({ isSelectable }: { isSelectable: boolean }) =>
    !isSelectable ? '#e3e3e3' : ''};
  cursor: ${({ isSelectable }: { isSelectable: boolean }) =>
    isSelectable ? 'pointer' : 'default'};

  :hover {
    background: ${({ isSelectable }: { isSelectable: boolean }) =>
      isSelectable ? '#f7f7f7' : ''};
  }

  :not(:disabled):active {
    background: #e3e3e3;
  }
  :focus {
    outline: none;
  }
`

export const MenuStyle = styled.div`
  z-index: 10;
  width: 100% !important;
  height: auto;
  min-height: min-content;
  max-height: 208px;
  background-color: white;
  border-radius: 4px;
`

export const CardInputStyle = styled.div`
  background: ${({ isSelected }: { isSelected: boolean }) =>
    isSelected ? '#e3e3e3' : 'white'};
  width: 100%;
  border-radius: 4px;
  padding: 2px;
  min-height: 40px;
`

export const TitleCloseStyle = styled.span`
  overflow: hidden;
  color: #fff;
  font-variant-numeric: lining-nums proportional-nums;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: Vollkorn, serif;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: 100%; /* 14px */
  letter-spacing: -0.14px;
  max-width: 308px;
`

export const AuthorInitialNameStyle = styled.span`
  text-align: center;
  color: #3b3b3b;
  /* Body/B1 - Fira - Medium */
  font-family: Fira Sans, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  padding-top: 5px;
  background: #f7f7f7;
  width: 30px;
  height: 30px;
  border-radius: 5px;
`
